export const casparCGENVBuilder = () => `
    let CASPARCG_ENV = false;
    if (window.caspar || window.casparcg || window.tickAnimations) {
        CASPARCG_ENV = true;
    }
`;
